import { render } from "./Laporan2A.vue?vue&type=template&id=278eba46"
import script from "./Laporan2A.vue?vue&type=script&lang=js"
export * from "./Laporan2A.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__